module.exports = __webpack_public_path__ + "static/img/maintenance.456ba489.png";